import { useEffect} from 'react'
import { useMap } from 'react-leaflet'
import L  from 'leaflet'

const FlyTo = (props) => {
    const { location, resetLocation } = props
    const map = useMap();
    
    useEffect(() => {
        if(location?.location?.lat && location?.location?.long){
          const lat = location.location.lat;
          const long = location.location.long;
          const zoom = location.zoom;

          map.flyTo(L.latLng(lat,long), zoom);
          resetLocation({});
        }
    }, [location])
    return null;
}

export default FlyTo;